module.exports = __webpack_public_path__ + "static/media/earthing_hardware.b72a73c3.webp";